import { ref, uploadBytes, getDownloadURL } from 'firebase/storage';
import { storage } from '../firebase';
import { compressImage } from './compress';

/**
 * Compresses a base64 dataUrl and uploads it to Firebase Storage.
 * Returns the public download URL.
 * Path: images/{shareToken}/{blockId}_{timestamp}.jpg
 */
export const uploadImage = async (dataUrl, shareToken, blockId) => {
  const compressed = await compressImage(dataUrl, 1200, 0.75);

  // Convert base64 to Blob
  const res = await fetch(compressed);
  const blob = await res.blob();

  const path = `images/${shareToken}/${blockId}_${Date.now()}.jpg`;
  const storageRef = ref(storage, path);

  await uploadBytes(storageRef, blob, { contentType: 'image/jpeg' });
  return getDownloadURL(storageRef);
};
